import { headers } from './requestConfig';
import {
  friendlyTeams,
  friendlyOffer,
  friendlyData,
  friendlyAcceptOffer,
  friendlyRejectOffer,
  friendlyCancelOffer,
} from '../service/links';

export const getFriendlyTeams = async () => {
  const response = await fetch(friendlyTeams, {
    method: 'GET',
    headers,
    credentials: 'include',
  });
  return response;
};

export const sendFriendlyOffer = async (opponent) => {
  const response = await fetch(friendlyOffer, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify({
      opponent,
    }),
  });
  return response;
};

export const getFriendlyData = async () => {
  const response = await fetch(friendlyData, {
    method: 'GET',
    headers,
    credentials: 'include',
  });
  return response;
};

export const acceptFriendlyOffer = async (offer) => {
  const response = await fetch(friendlyAcceptOffer, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify({ offer }),
  });
  return response;
};

export const rejectFriendlyOffer = async (offer) => {
  const response = await fetch(friendlyRejectOffer, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify({ offer }),
  });
  return response;
};

export const cancelFriendlyOffer = async (offer) => {
  const response = await fetch(friendlyCancelOffer, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify({ offer }),
  });
  return response;
};
